import script from "./AddNewButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewButton.vue?vue&type=script&setup=true&lang=js"

import "./AddNewButton.vue?vue&type=style&index=0&id=0bc20101&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc20101"]])

export default __exports__